import styled from 'styled-components';
import { Row } from 'react-bootstrap';

export const StyledFiltersRow = styled(Row)`
  label {
    padding-left: 0;
  }
`;
